import React from 'react';
import AuthCanvas from './AuthCanvas';

/**
 * Panneau visuel droit — réutilisé sur Login & Register
 * Reproduit fidèlement les sections visual-side des maquettes
 */
export default function AuthVisual({ variant = 'login' }) {
  const isLogin = variant === 'login';

  const head = isLogin
    ? <>Simplifiez vos envois<br />vers <em>l'Afrique.</em></>
    : <>Rejoignez<br />Colis2Ship <em>dès aujourd'hui.</em></>;

  const sub = isLogin
    ? "Des transporteurs vérifiés emportent vos colis entre l'Europe, l'Afrique et l'Amérique. Le paiement reste retenu jusqu'à la livraison."
    : "Choisissez votre rôle et commencez à envoyer ou transporter des colis en quelques minutes.";

  const trust = isLogin
    ? [
        { ic: '🔒', t: 'Paiement retenu par Stripe jusqu’à la livraison' },
        { ic: '🛡️', t: 'Membres vérifiés : e-mail, téléphone, pièce d’identité' },
        { ic: '📦', t: 'Remise du colis confirmée par un code unique' },
      ]
    : [
        { ic: '⚡', t: 'Inscription en quelques minutes' },
        { ic: '🛡️', t: 'Vérifications demandées avant de publier ou de proposer' },
        { ic: '🔒', t: 'Paiement retenu par Stripe jusqu’à la livraison' },
      ];

  return (
    <div className="visual-side">
      <AuthCanvas />
      <div className="visual-overlay" />
      <div className="visual-content">
        <div className="brand brand--light">
          <div className="brand-mark">C2</div>
          <span className="brand-name">Colis<em>2</em>Ship</span>
        </div>

        <div className="illus-wrap">
          {isLogin ? <IllusLogin /> : <IllusRegister />}
        </div>

        <h2 className="visual-head">{head}</h2>
        <p className="visual-sub">{sub}</p>

        <div className="visual-trust">
          {trust.map((row, i) => (
            <div key={i} className="tr-row">
              <div className="tr-ic">{row.ic}</div>
              {row.t}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

/* ───── SVG illustrations ───── */

function IllusLogin() {
  return (
    <svg width="280" height="210" viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <ellipse cx="140" cy="196" rx="110" ry="8" fill="rgba(0,0,0,.25)" />
      {/* Expéditeur gauche */}
      <rect x="34" y="140" width="10" height="30" rx="5" fill="#0f172a" />
      <rect x="46" y="140" width="10" height="30" rx="5" fill="#0f172a" />
      <rect x="31" y="166" width="15" height="7" rx="3" fill="#080d1a" />
      <rect x="43" y="166" width="15" height="7" rx="3" fill="#080d1a" />
      <rect x="28" y="92" width="38" height="54" rx="10" fill="#1e2d45" />
      <rect x="32" y="92" width="30" height="32" rx="8" fill="#2d4060" />
      <rect x="38" y="92" width="12" height="10" rx="4" fill="#F0C97A" />
      <circle cx="47" cy="76" r="17" fill="#d4a878" />
      <path d="M32 70 Q47 54 62 70 Q60 64 47 60 Q34 64 32 70Z" fill="#2c1a0a" />
      <rect x="64" y="100" width="22" height="9" rx="4.5" fill="#2d4060" transform="rotate(-12 64 100)" />
      {/* Colis centre */}
      <g>
        <rect x="104" y="74" width="72" height="58" rx="7" fill="#F0C97A" />
        <path d="M104 74 L140 64 L176 74 L140 84Z" fill="#f7de8a" />
        <path d="M176 74 L186 82 L186 130 L176 132Z" fill="#c8a020" />
        <rect x="104" y="96" width="72" height="8" rx="2" fill="rgba(15,23,42,.22)" />
        <rect x="136" y="74" width="8" height="58" rx="2" fill="rgba(15,23,42,.22)" />
        <circle cx="140" cy="96" r="7" fill="rgba(255,255,255,.7)" />
        <ellipse cx="137" cy="94" rx="5" ry="4" fill="rgba(255,255,255,.4)" />
        <ellipse cx="143" cy="98" rx="5" ry="4" fill="rgba(255,255,255,.4)" />
        <rect x="112" y="108" width="28" height="16" rx="3" fill="rgba(255,255,255,.75)" />
        <rect x="115" y="111" width="22" height="2" rx="1" fill="rgba(15,23,42,.4)" />
        <rect x="115" y="115" width="16" height="2" rx="1" fill="rgba(15,23,42,.25)" />
        <rect x="115" y="119" width="19" height="2" rx="1" fill="rgba(15,23,42,.2)" />
        <animateTransform attributeName="transform" type="translate" values="0 0;0 -6;0 0" dur="2.8s" repeatCount="indefinite" calcMode="spline" keySplines="0.45 0 0.55 1;0.45 0 0.55 1" />
      </g>
      {/* Flèches */}
      <g opacity=".8">
        <line x1="86" y1="108" x2="106" y2="108" stroke="#7ecfc2" strokeWidth="2.5" strokeDasharray="5 3">
          <animate attributeName="stroke-dashoffset" from="0" to="-16" dur="1s" repeatCount="indefinite" />
        </line>
        <polygon points="106,103 116,108 106,113" fill="#7ecfc2" />
      </g>
      <g opacity=".8">
        <line x1="194" y1="108" x2="174" y2="108" stroke="#F0C97A" strokeWidth="2.5" strokeDasharray="5 3">
          <animate attributeName="stroke-dashoffset" from="0" to="-16" dur="1s" begin=".3s" repeatCount="indefinite" />
        </line>
        <polygon points="174,103 164,108 174,113" fill="#F0C97A" />
      </g>
      {/* Transporteur droite */}
      <rect x="194" y="140" width="36" height="28" rx="6" fill="#162035" />
      <rect x="202" y="135" width="20" height="7" rx="3" fill="#0f172a" />
      <rect x="206" y="143" width="12" height="16" rx="2" fill="rgba(240,201,122,.12)" />
      <rect x="198" y="151" width="36" height="4" fill="#F0C97A" opacity=".5" />
      <circle cx="216" cy="165" r="4" fill="rgba(255,255,255,.2)" />
      <rect x="196" y="138" width="10" height="30" rx="5" fill="#0f172a" />
      <rect x="208" y="138" width="10" height="30" rx="5" fill="#0f172a" />
      <rect x="193" y="164" width="15" height="7" rx="3" fill="#080d1a" />
      <rect x="205" y="164" width="15" height="7" rx="3" fill="#080d1a" />
      <rect x="192" y="88" width="38" height="56" rx="10" fill="#162035" />
      <rect x="196" y="88" width="30" height="34" rx="8" fill="#1e2d45" />
      <rect x="204" y="95" width="18" height="10" rx="2" fill="#F0C97A" />
      <text x="213" y="103" fontFamily="system-ui" fontSize="5.5" fontWeight="800" fill="#0f172a" textAnchor="middle">C2S</text>
      <circle cx="211" cy="72" r="17" fill="#c8a882" />
      <path d="M196 66 Q211 50 226 66 Q224 60 211 56 Q198 60 196 66Z" fill="#1a0a00" />
      <rect x="176" y="98" width="22" height="9" rx="4.5" fill="#1e2d45" transform="rotate(12 176 98)" />
      {/* Particules */}
      <circle cx="140" cy="50" r="3.5" fill="#7ecfc2" opacity=".5">
        <animate attributeName="r" values="3.5;5.5;3.5" dur="2.2s" repeatCount="indefinite" />
        <animate attributeName="opacity" values=".5;.1;.5" dur="2.2s" repeatCount="indefinite" />
      </circle>
      <circle cx="96" cy="60" r="2.5" fill="#F0C97A" opacity=".45">
        <animate attributeName="opacity" values=".45;.08;.45" dur="1.8s" begin=".5s" repeatCount="indefinite" />
      </circle>
      <circle cx="188" cy="55" r="2.5" fill="#F0C97A" opacity=".4">
        <animate attributeName="opacity" values=".4;.06;.4" dur="2s" begin=".9s" repeatCount="indefinite" />
      </circle>
    </svg>
  );
}

function IllusRegister() {
  return (
    <svg width="280" height="210" viewBox="0 0 280 210" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <ellipse cx="140" cy="196" rx="110" ry="8" fill="rgba(0,0,0,.25)" />
      {/* Expéditeur gauche */}
      <rect x="22" y="138" width="10" height="32" rx="5" fill="#0f172a" />
      <rect x="34" y="138" width="10" height="32" rx="5" fill="#0f172a" />
      <rect x="19" y="165" width="15" height="7" rx="3" fill="#080d1a" />
      <rect x="31" y="165" width="15" height="7" rx="3" fill="#080d1a" />
      <path d="M18 130 Q28 150 46 148 L44 130Z" fill="#F0C97A" opacity=".6" />
      <rect x="18" y="88" width="36" height="48" rx="10" fill="#2d4060" />
      <rect x="22" y="88" width="28" height="28" rx="8" fill="#3d5a80" />
      <rect x="54" y="100" width="14" height="22" rx="3" fill="#162035" stroke="#7ecfc2" strokeWidth="1.5" />
      <rect x="56" y="103" width="10" height="14" rx="1" fill="#1e3a5f" />
      <rect x="56" y="119" width="10" height="1.5" rx="1" fill="#7ecfc2" opacity=".7" />
      <rect x="52" y="102" width="20" height="8" rx="4" fill="#3d5a80" transform="rotate(-10 52 102)" />
      <circle cx="36" cy="72" r="16" fill="#d4a878" />
      <path d="M22 68 Q36 52 50 68 L52 85 Q36 92 20 85Z" fill="#2c1a0a" opacity=".85" />
      {/* Colis */}
      <g>
        <rect x="88" y="80" width="52" height="44" rx="5" fill="#F0C97A" />
        <path d="M88 80 L114 72 L140 80 L114 88Z" fill="#f7de8a" />
        <path d="M140 80 L148 86 L148 124 L140 124Z" fill="#c8a020" />
        <rect x="88" y="96" width="52" height="6" rx="1" fill="rgba(15,23,42,.2)" />
        <rect x="111" y="80" width="6" height="44" rx="1" fill="rgba(15,23,42,.2)" />
        <circle cx="114" cy="96" r="5" fill="rgba(255,255,255,.65)" />
        <animateTransform attributeName="transform" type="translate" values="0 0;0 -5;0 0" dur="2.6s" repeatCount="indefinite" />
      </g>
      {/* Transporteur centre */}
      <rect x="122" y="150" width="34" height="22" rx="5" fill="#162035" />
      <rect x="130" y="145" width="18" height="7" rx="3" fill="#0f172a" />
      <rect x="122" y="138" width="10" height="28" rx="5" fill="#0f172a" />
      <rect x="135" y="138" width="10" height="28" rx="5" fill="#0f172a" />
      <rect x="116" y="86" width="40" height="56" rx="10" fill="#162035" />
      <rect x="120" y="86" width="32" height="36" rx="8" fill="#1e2d45" />
      <rect x="128" y="93" width="18" height="10" rx="2" fill="#F0C97A" />
      <text x="137" y="101" fontFamily="system-ui" fontSize="5.5" fontWeight="800" fill="#0f172a" textAnchor="middle">C2S</text>
      <circle cx="136" cy="70" r="17" fill="#c8a882" />
      <path d="M121 64 Q136 48 151 64 Q149 58 136 54 Q123 58 121 64Z" fill="#1a0a00" />
      {/* Destinataire droite */}
      <rect x="226" y="136" width="10" height="34" rx="5" fill="#0f172a" />
      <rect x="238" y="136" width="10" height="34" rx="5" fill="#0f172a" />
      <rect x="220" y="86" width="38" height="54" rx="10" fill="#2d4060" />
      <rect x="224" y="86" width="30" height="30" rx="8" fill="#3d5a80" />
      <circle cx="239" cy="70" r="16" fill="#b8865a" />
      <path d="M225 64 Q239 50 253 64 Q251 58 239 56 Q227 58 225 64Z" fill="#0a0500" />
      {/* Colis droite */}
      <g transform="translate(186,88)">
        <rect x="0" y="0" width="40" height="32" rx="5" fill="#7ecfc2" opacity=".9" />
        <path d="M0 0 L20 -6 L40 0 L20 6Z" fill="#a0e0d4" opacity=".9" />
        <path d="M40 0 L46 5 L46 32 L40 32Z" fill="#4aaa96" opacity=".9" />
      </g>
      {/* Connexions */}
      <line x1="72" y1="105" x2="90" y2="105" stroke="#7ecfc2" strokeWidth="2" strokeDasharray="5 3" opacity=".7">
        <animate attributeName="stroke-dashoffset" from="0" to="-16" dur="1s" repeatCount="indefinite" />
      </line>
      <line x1="164" y1="105" x2="188" y2="105" stroke="#F0C97A" strokeWidth="2" strokeDasharray="5 3" opacity=".7">
        <animate attributeName="stroke-dashoffset" from="0" to="-16" dur="1s" begin=".4s" repeatCount="indefinite" />
      </line>
    </svg>
  );
}
